import { Injectable } from '@angular/core';
import {Notification} from './notification.model';
import {Subject} from 'rxjs/Subject';

export class NotifierService {
    notifications: Notification[] = [];
    notificationAdded = new Subject<Notification[]>();




    notify (message: string, level: string) : any {
        let note = new Notification(message, level);
        this.notifications.push(note);
        this.notificationAdded.next(this.notifications.slice());
    }

}



// WEBPACK FOOTER //
// ./src/app/notifier/notifier.service.ts